import { Subject, Observable, from } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class EventsService {
  private listeners: any;
  private eventsSubject: any;
  private events;
  constructor() {
    this.listeners = {};
    this.eventsSubject = new Subject();
    this.events = from(this.eventsSubject);

    this.events.subscribe(
      ({ name, args }) => {
        if (this.listeners[name]) {
          for (let listener of this.listeners[name]) {
            listener(...args);
          }
        }
      });
  }

  on(name, listener) {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }

    this.listeners[name].push(listener);
  }

  off(name, listener, isClearAll = false) {
    if (isClearAll)
      this.listeners[name] = [];
    else if(this.listeners[name] && this.listeners[name].length) {
      let index = this.listeners[name].findIndex(x => x == listener);
      if(index > -1){
        this.listeners[name].splice(index, 1);
      }
    }
  }

  broadcast(name, ...args) {
    this.eventsSubject.next({
      name,
      args
    });
  }
}